export default __webpack_public_path__ + "static/media/vector.4a1ad3ef.svg";